<template>
  <div>
    <carousel-dots
      :height="
        isScreenMobile
          ? bigMobile
            ? '58vh'
            : '70vh'
          : smallLaptops
          ? '90vh'
          : '80vh'
      "
      arrow="always"
      space-bottom="negative"
    >
      <el-carousel-item v-for="(item, i) in items" :key="i">
        <div>
          <div class="row mx-2 mx-lg-0 px-lg-5 justify-content-center">
            <div
              class="col-lg-4 col-10 order-lg-0 order-1 px-lg-5 px-4 bg-brown d-flex flex-column justify-content-start pb-lg-0 pb-3 pt-3 pt-lg-5"
            >
              <h5 class="text-ligth-green mb-2 mb-lg-4 pt-lg-0 pt-3">
                {{ conferenceType(item.conference_type) }}
              </h5>

              <h2>
                {{ item?.name }}
              </h2>

              <h5 class="text-ligth-green mb-3">
                {{ item.year }}
              </h5>

              <p class="mb-0" v-html="item.conference?.description"></p>

              <div class="d-flex align-items-center mt-2 mt-lg-3">
                <router-link
                  :to="{
                    name: 'conference-about',
                    params: { id: item.id },
                  }"
                  class="btn btn-play me-3"
                >
                  <div class="icon-play btn-circle" />
                </router-link>
              </div>
            </div>
            <router-link
              class="col-lg-6 col-10 order-lg-1 order-0 ps-0 playbutton bg-preview position-relative"
              :style="{
                'background-image': `url(${require('@/assets/images/icons/play.svg')}), url(${
                  item.cover
                })`,
              }"
              :to="{
                name: 'conference-about',
                params: { id: item.id },
              }"
            >
              <!-- <img
              src=""
              alt="iniciar"
              class="position-absolute play-video"
              width="93.75"
              height="79.69"
            > -->
            </router-link>

            <!-- <div class="col-lg-12 d-flex justify-content-center">
            <div class="wrapper-horizontal-controllers d-flex">
              <div
                v-for="(item, index) in items"
                @click="setItemIndex(index)"
                :key="item.id"
                class="controller-horizontal mt-3"
                :class="{'is-active' : item.id === item.id}"
              />
            </div>
          </div> -->
          </div>
        </div>
      </el-carousel-item>
    </carousel-dots>
  </div>
</template>

<script>
  import CarouselDots from "@/components/thumbnails/CarouselDots.vue";
  // import AddToList from "../buttons/AddToList.vue";

  export default {
    components: {
      // AddToList,
      CarouselDots,
    },
    props: {
      items: {
        required: false,
        default: () => {},
        type: Object,
      },
    },
    data() {
      return {
        itemIndex: 0,
      };
    },
    methods: {
      prev() {
        this.itemIndex < this.items.length - 1 ? this.itemIndex++ : "";
      },
      next() {
        this.itemIndex > 0 ? this.itemIndex-- : "";
      },
      setItemIndex(index) {
        this.itemIndex = index;
      },
      conferenceType(conference_type) {
        switch (conference_type) {
          case "all":
            return "Conferência Fiel";
          case "young":
            return "Conferência Fiel Jovens";
          case "women":
            return "Conferência Fiel Mulheres";
          case "pastors-and-leaders":
            return "Conferência Fiel Pastores e Líderes";
          default:
            return conference_type;
        }
      },
    },
    computed: {
      itemCurrent() {
        return this.items[this.itemIndex];
      },
      isScreenMobile() {
        return screen.width < 992;
      },
      bigMobile() {
        return screen.width > 375;
      },
      smallLaptops() {
        return screen.width < 1300;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/_variables.scss";

  .wrapper-horizontal-controllers {
    .controller-horizontal {
      width: 29.5px;
      height: 4px;
      border-radius: 8px;
      background-color: #c4c4c4;
      margin: 0.2rem 0.5rem 0.2rem 0.5rem;

      cursor: pointer;

      @media (min-width: 992px) {
        margin: 0.2rem;
      }

      &.is-active {
        background: $primary;
        border-radius: 8px;
      }
    }
  }

  .bg-brown {
    background-color: #407f59;
    @media (max-width: 768px) {
      border-radius: 0 0 10px 10px;
    }
  }

  h5,
  p {
    &,
    & * {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;

      @media (min-width: 992px) {
        font-size: 16px;
      }
    }
  }

  :deep(p) {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;

    @media (min-width: 992px) {
      -webkit-line-clamp: 6;
      line-clamp: 6;
    }
  }

  h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 38px;

    @media (min-width: 992px) {
      font-size: 36px;
    }

    @media (max-width: 768px) {
      font-size: 25px;
      line-height: 33px;
    }
  }

  .text-ligth-green {
    color: #83e2ac;
  }

  .bg-preview {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 25px, cover;
    @media (min-width: 992px) {
      background-size: 50px, cover;
    }

    aspect-ratio: 643/589;

    @media (max-width: 768px) {
      border-radius: 10px 10px 0 0;
      max-height: 160px;
    }
  }

  .icon-outline-play {
    font-size: 23px;
  }

  .play-video {
    left: 50%;
    top: 50%;
  }

  button {
    background-color: transparent;
    border: 1px solid transparent;

    & .controller {
      color: white;
      background: none;
      font-size: 45px;
      font-weight: bold;
    }
  }

  :deep(.el-carousel__indicators) {
    @media (max-width: 768px) {
      width: fit-content !important;
    }
  }
</style>
